import * as Sentry from '@sentry/vue'
import type { User } from '@/modules/Auth/types/model/user'

export default function useSentry() {
  function setUserContext(user: User) {
    Sentry.setUser(user)
  }

  function setTenantContext(tenant: string) {
    Sentry.setTag('tenant', tenant)
  }

  function trackSearchContext(
    searchId: string,
    {
      userId,
      guestId,
    }:
      | {
          userId: string | undefined
          guestId?: undefined
        }
      | {
          guestId: string | undefined
          userId?: undefined
        }
  ) {
    Sentry.setTag('search.id', searchId)

    if (userId) {
      Sentry.setTag('search.user.id', userId)
    }

    if (guestId) {
      Sentry.setTag('search.guest.id', guestId)
    }
  }

  function setFeatureFlagId(id: string) {
    Sentry.setTag('featureFlag.id', id)
  }

  function clearContext() {
    const scope = Sentry.getCurrentScope()
    scope.setUser(null)
    scope.setTags({})
  }

  return {
    setUserContext,
    setTenantContext,
    trackSearchContext,
    clearContext,
    setFeatureFlagId,
  }
}
